export default __webpack_public_path__ + "static/media/root.9a728100.png";